
import Link from 'next/link';
import Router from 'next/router';
import { Component, createRef, useEffect, useMemo, useRef, useState } from 'react';
import styles from './process-select-dropdown.component.module.scss';
import { ProcessSelectionRawData } from '../models/process-selection-row-data';
import { createPopper } from '@popperjs/core';

interface ProcessSelectionDropdownProps {
    id?: string;
    options: ProcessSelectionRawData[];
    selectedOption: ProcessSelectionRawData | null;
    formatOption: (value: ProcessSelectionRawData | null) => string;
    onChange: (value: ProcessSelectionRawData | null) => void;
}

interface ProcessSelectionDropdownState {
    isOpen: boolean;
    selectedProcess: string;
}

export class ProcessSelectionDropdown extends Component<ProcessSelectionDropdownProps, ProcessSelectionDropdownState> {
    // A ref to the main container to detect outside clicks
    private dropdownRef = createRef<HTMLDivElement>();
    private dropdownMenuRef = createRef<HTMLDivElement>();

    constructor(props: ProcessSelectionDropdownProps) {
        super(props);

        // Initialize state
        this.state = {
            isOpen: false,
            selectedProcess: props.selectedOption?.process || '',
        };
    }

    // Add event listener when the component mounts
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    // Clean up the event listener when the component unmounts
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    // Method to close dropdown if a click occurs outside of it
    handleClickOutside = (event: MouseEvent) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target as Node)) {
            this.setState({ isOpen: false });
        }
    };

    // Method to handle selecting an option
    handleSelectOption = (option: ProcessSelectionRawData) => {
        this.props.onChange(option);
        this.setState({
            isOpen: false,
        });
    };

    // Method to toggle the dropdown's visibility
    toggleDropdown = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    };

    componentDidUpdate(prevProps: ProcessSelectionDropdownProps, prevState: ProcessSelectionDropdownState) {
        if (this.state.isOpen && !prevState.isOpen && this.props.selectedOption) {
            const selectedElement = document.getElementById(`option-${this.props.selectedOption.process}`);
            if (selectedElement) {
                selectedElement.scrollIntoView({ block: 'nearest' });
            }
        }
    }

    render() {
        const { options, selectedOption } = this.props;
        const { isOpen, selectedProcess } = this.state;

        return (
            <div className={`${styles["dropdown-container"]} `} ref={this.dropdownRef} id={this.props.id}>
                <button className={`${styles["dropdown-button"]}`} onClick={this.toggleDropdown}>
                    {this.props.formatOption(selectedOption)}
                </button>
                <div className={`${styles["dropdown-menu"]} 
                        ${isOpen || 'hidden'}`} ref={this.dropdownMenuRef}>
                    <div className={`${styles["dropdown-body"]}`}>
                        {isOpen && (<ul className={`${styles["dropdown-categories"]}`}>
                            {this.props.options.map((option) => (
                                <li
                                    key={option.process}
                                    id={`option-${option.process}`}
                                    className={option.process === selectedOption?.process ? styles.active : ''}
                                    onClick={() => this.handleSelectOption(option)}
                                >
                                    {this.props.formatOption(option)}
                                </li>
                            ))}
                        </ul>)}
                    </div>
                </div>

            </div>
        );
    }
}

